var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"touchpointText",staticClass:"generic-touchpoint__text",class:{ 'generic-touchpoint__text--double': _vm.isDouble }},[_vm._v(" "+_vm._s(_vm.content)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }